/* eslint-disable react/no-unused-state */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-undef */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-empty */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash';
import queryString from 'query-string';
import React from 'react';
import ReactPaginate from 'react-paginate';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { isMobile } from 'react-device-detect';
import {
  getProductsRecommended,
  getProductsSearch,
  setFiltersSidebar,
  setOrderType,
} from '../app/store/actions/products';
import Breadcrumb from '../components/breadcrumb/Breadcrumb';
import ProductItem from '../components/productElements/ProductItem';
import { appendScript, removeScript } from '../components/utils';
import ProductsData from '../data/products';
import ROUTES from '../data/routes';
import { history } from '../routers/AppRouter';
import Banner from '../components/banner/banner';

const refreshPage = _.throttle(
  async (updateItems, getProductsRecommendedFun) => {
    try {
      await updateItems();
      await getProductsRecommendedFun();
    } catch (e) {}

    removeScript('/scripts/search.min.js');
    appendScript('/scripts/search.min.js');
  },
  1000,
  { trailing: false },
);

export class ProductsFilters extends React.PureComponent {
  state = {
    subCategoriesItems: categories => (categories != null ? categories.sort((a, b) => b.total - a.total) : []),
    productTypeItems: (selectedPdmModifier, pdmsModifiers) => (selectedPdmModifier
      ? pdmsModifiers
        .sort((a, b) => b.total - a.total)
        .filter(item => `${item.id}` === `${selectedPdmModifier}`)
      : pdmsModifiers.sort((a, b) => b.total - a.total)),
    brandsItems: brands => brands.sort((a, b) => b.total - a.total),
    sortByClickS: 1,
    sortByClickP: 1,
    sortByClickB: 1,
    minPrice: '1',
    maxPrice: '10000',
    categoryGreen: null,
  };

  componentDidMount = () => {
    const {
      search, sortByClickS, sortByClickP, sortByClickB, categories,
    } = this.props;
    let minPriceStr = '1';
    let maxPriceStr = '10000';

    if (search.minPrice) {
      try {
        $('#min').val(
          `R$ ${parseFloat(search.minPrice).toLocaleString('pt-br', {
            minimumFractionDigits: 2,
          })}`,
        );
        minPriceStr = search.minPrice;
      } catch (e) {}
    }
    if (search.maxPrice) {
      try {
        $('#max').val(
          `R$ ${parseFloat(search.maxPrice).toLocaleString('pt-br', {
            minimumFractionDigits: 2,
          })}`,
        );
        maxPriceStr = search.maxPrice;
      } catch (e) {}
    }
    if (categories && categories.length > 0) {
      const greenCategory = categories.find(category => category.name === 'PORTFÓLIO VERDE');
      if (greenCategory) {
        this.setState({ categoryGreen: greenCategory.id });
      }
    }

    this.setState({
      minPrice: minPriceStr,
      maxPrice: maxPriceStr,
      sortByClickS,
      sortByClickP,
      sortByClickB,
    });
  };

  updatePdmParticulars = (particular, value) => {
    const { search } = this.props;
    const newSearch = search.pdmsParticulars || [];

    const particularIndex = newSearch.findIndex(
      p => p.split(': ')[0] === particular,
    );
    if (particularIndex !== -1) newSearch.splice(particularIndex, 1);

    if (value) newSearch.push(`${particular}: ${value}`);
    this.props.updateSearch({ pdmsParticulars: newSearch });
  };

  subCategoriesClick = () => {
    this.setState({ sortByClickS: this.state.sortByClickS + 1 });
    this.state.sortByClickS === 1
      ? this.setState({
        subCategoriesItems: categories => (categories != null
          ? categories.sort((a, b) => (a.value < b.value ? -1 : 1))
          : []),
      })
      : null;
    this.state.sortByClickS === 2
      ? this.setState({
        subCategoriesItems: categories => (categories != null
          ? categories.sort((a, b) => (a.value > b.value ? -1 : 1))
          : []),
      })
      : null;
    this.state.sortByClickS === 3
      ? this.setState({
        subCategoriesItems: categories => (categories != null
          ? categories.sort((a, b) => b.total - a.total)
          : []),
      })
      : null;
    this.state.sortByClickS >= 3 ? this.setState({ sortByClickS: 1 }) : null;
  };

  productTypeClick = () => {
    this.setState({ sortByClickP: this.state.sortByClickP + 1 });
    this.state.sortByClickP === 1
      ? this.setState({
        productTypeItems: (selectedPdmModifier, pdmsModifiers) => (selectedPdmModifier
          ? pdmsModifiers
            .sort((a, b) => (a.value < b.value ? -1 : 1))
            .filter(item => `${item.id}` === `${selectedPdmModifier}`)
          : pdmsModifiers.sort((a, b) => (a.value < b.value ? -1 : 1))),
      })
      : null;
    this.state.sortByClickP === 2
      ? this.setState({
        productTypeItems: (selectedPdmModifier, pdmsModifiers) => (selectedPdmModifier
          ? pdmsModifiers
            .sort((a, b) => (a.value > b.value ? -1 : 1))
            .filter(item => `${item.id}` === `${selectedPdmModifier}`)
          : pdmsModifiers.sort((a, b) => (a.value > b.value ? -1 : 1))),
      })
      : null;
    this.state.sortByClickP === 3
      ? this.setState({
        productTypeItems: (selectedPdmModifier, pdmsModifiers) => (selectedPdmModifier
          ? pdmsModifiers
            .sort((a, b) => b.total - a.total)
            .filter(item => `${item.id}` === `${selectedPdmModifier}`)
          : pdmsModifiers.sort((a, b) => b.total - a.total)),
      })
      : null;
    this.state.sortByClickP >= 3 ? this.setState({ sortByClickP: 1 }) : null;
  };

  brandsClick = () => {
    this.setState({ sortByClickB: this.state.sortByClickB + 1 });
    this.state.sortByClickB === 1
      ? this.setState({
        brandsItems: brands => brands.sort((a, b) => (a.value < b.value ? -1 : 1)),
      })
      : null;
    this.state.sortByClickB === 2
      ? this.setState({
        brandsItems: brands => brands.sort((a, b) => (a.value > b.value ? -1 : 1)),
      })
      : null;
    this.state.sortByClickB === 3
      ? this.setState({
        brandsItems: brands => brands.sort((a, b) => b.total - a.total),
      })
      : null;
    this.state.sortByClickB >= 3 ? this.setState({ sortByClickB: 1 }) : null;
  };

  onClickApplyPrice = () => {
    let minPriceValue = 0;
    let maxPriceValue = 0;

    try {
      minPriceValue = $('#min').maskMoney('unmasked')[0];
    } catch (e) {}
    try {
      maxPriceValue = $('#max').maskMoney('unmasked')[0];
    } catch (e) {}

    if (minPriceValue || maxPriceValue) {
      this.props.updateSearch({
        minPrice: minPriceValue,
        maxPrice: maxPriceValue,
      });
    }
  };

  closeFilter = () => {
    try {
      $('.closeBoxFixed').click();
    } catch (e) {}
  };

  renderProductsSection = ({
    type, onClick, contractSelected, user, categorySelected, categoryGreen,
  }) => (
    <div className="filter-header">
      <button
        type="button"
        style={{ height: '40px', fontSize: '14px' }}
        className={`search-btn ${(!type || type !== 'greenOffer') || !categorySelected ? 'active' : ''}`}
        onClick={() => onClick({
          type: '',
          categories: [],
          brands: [],
          pdmsModifiers: [],
          pdmsParticulars: [],
          greenIndicators: [],
        })
        }
        onKeyDown={() => onClick({
          type: '',
          categories: [],
          brands: [],
          pdmsModifiers: [],
          pdmsParticulars: [],
          greenIndicators: [],
        })
        }
      >
        {I18n.t('all')}
      </button>
      <button
        type="button"
        style={{ height: '40px', fontSize: '14px' }}
        className={`search-btn ${type === 'spotlight' ? 'active' : ''}`}
        onClick={() => onClick({ type: 'spotlight', greenIndicators: [] })}
        onKeyDown={() => onClick({ type: 'spotlight', greenIndicators: [] })}
      >
        {I18n.t('spotlight')}
      </button>

      <button
        type="button"
        style={{ height: '40px', fontSize: '14px' }}
        className={`search-btn ${type === 'greenOffer' ? 'active' : ''}`}
        onClick={() => onClick({ categories: [categoryGreen], type: 'greenOffer' })}
        onKeyDown={() => onClick({ categories: [categoryGreen], type: 'greenOffer' })}
      >
        {I18n.t('greenPortfolio')}
      </button>
      {contractSelected && (
      <button
        type="button"
        style={{ height: '40px', fontSize: '14px' }}
        className={`search-btn ${type === 'contract' ? 'active' : ''}`}
        onClick={() => onClick({ type: 'contract', greenIndicators: [] })}
        onKeyDown={() => onClick({ type: 'contract', greenIndicators: [] })}
      >
        {I18n.t('contract')}
      </button>
      )}
      {user && (
      <button
        type="button"
        style={{ height: '40px', fontSize: '14px' }}
        className={`search-btn ${type === 'agreement' ? 'active' : ''}`}
        onClick={() => onClick({ type: 'agreement', greenIndicators: [] })}
        onKeyDown={() => onClick({ type: 'agreement', greenIndicators: [] })}
      >
        {I18n.t('agreement')}
      </button>
      )}
    </div>
  );

  renderSection = ({
    title,
    items = [],
    selected,
    onClick,
    clickAttr,
    basicAttrs = {},
    reset,
    typeClassElement = 'radio',
  }) => !!(items && items.length) && (
  <div className="filter" key={title}>
    <span className="filter-title" style={{ textTransform: 'capitalize' }}>
      {title.toUpperCase()}
      {reset && selected && (
      <span
        className="filter-title"
        style={{
          position: 'absolute',
          top: '1.8em',
          right: '0.5em',
          fontSize: 14,
          fontFamily: 'inter',
          fontWeight: '600',
          color: '#009FEC',
          cursor: 'pointer',
        }}
        onClick={reset}
        onKeyDown={reset}
        role="presentation"
      >
        {I18n.t('clear')}
      </span>
      )}
    </span>

    <div className="filter-content">
      {items.map(item => (
        <div
          key={item.id}
          className="filter-item"
          onClick={() => onClick({ ...basicAttrs, [clickAttr]: [item.id] })}
          onKeyDown={() => onClick({ ...basicAttrs, [clickAttr]: [item.id] })
              }
          role="presentation"
        >
          <label className="label cursorPointer">
            <div className={typeClassElement}>
              <input
                type="radio"
                checked={
                      selected && `${selected}` !== `${item.id}`
                        ? ''
                        : 'checked'
                    }
                name=""
                readOnly
              />
              <span className="checkmark" />
            </div>
            {item.value}
          </label>
          {!!item.total && <span className="number">{item.total}</span>}
        </div>
      ))}
    </div>
  </div>
  );

  renderPriceSection = (minPrice, maxPrice) => (
    <div className="filter">
      <div style={{ position: 'relative' }}>
        <span className="filter-title">{I18n.t('price')}</span>
        <span
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            fontSize: 14,
            fontFamily: 'inter',
            fontWeight: 'bold',
            color: '#009FEC',
            cursor: 'pointer',
          }}
          onClick={this.onClickApplyPrice}
          onKeyDown={this.onClickApplyPrice}
          role="presentation"
        >
          {I18n.t('Aplicar')}
        </span>
      </div>

      <div id="preco-slide" />
      <input type="hidden" id="preco-minimo" value={minPrice} />
      <input type="hidden" id="preco-maximo" value={maxPrice} />

      <div className="filter-price">
        <div className="price-input">
          <span className="text">Min</span>
          <input
            className="input"
            type="text"
            name="minimo"
            id="min"
            placeholder="R$"
          />
        </div>
        <div className="price-separator">-</div>
        <div className="price-input">
          <span className="text">Max</span>
          <input
            className="input"
            type="text"
            name="maximo"
            id="max"
            placeholder="R$"
          />
        </div>
      </div>
    </div>
  );

  renderRatings = () => (
    <div className="filter">
      <span className="filter-title">Avaliações</span>
      <div className="filter-item">
        <label className="label">
          <div className="checkbox">
            <input type="checkbox" name="" />
            <span className="checkmark" />
          </div>
          <svg className="icon icon-rating icon--active">
            <use xlinkHref="#icon-rating" />
          </svg>
          <svg className="icon icon-rating icon--active">
            <use xlinkHref="#icon-rating" />
          </svg>
          <svg className="icon icon-rating icon--active">
            <use xlinkHref="#icon-rating" />
          </svg>
          <svg className="icon icon-rating icon--active">
            <use xlinkHref="#icon-rating" />
          </svg>
          <svg className="icon icon-rating icon--active">
            <use xlinkHref="#icon-rating" />
          </svg>
        </label>
      </div>
      <div className="filter-item">
        <label className="label">
          <div className="checkbox">
            <input type="checkbox" name="" />
            <span className="checkmark" />
          </div>
          <svg className="icon icon-rating icon--active">
            <use xlinkHref="#icon-rating" />
          </svg>
          <svg className="icon icon-rating icon--active">
            <use xlinkHref="#icon-rating" />
          </svg>
          <svg className="icon icon-rating icon--active">
            <use xlinkHref="#icon-rating" />
          </svg>
          <svg className="icon icon-rating icon--active">
            <use xlinkHref="#icon-rating" />
          </svg>
          <svg className="icon icon-rating">
            <use xlinkHref="#icon-rating" />
          </svg>
        </label>
      </div>
      <div className="filter-item">
        <label className="label">
          <div className="checkbox">
            <input type="checkbox" name="" />
            <span className="checkmark" />
          </div>
          <svg className="icon icon-rating icon--active">
            <use xlinkHref="#icon-rating" />
          </svg>
          <svg className="icon icon-rating icon--active">
            <use xlinkHref="#icon-rating" />
          </svg>
          <svg className="icon icon-rating icon--active">
            <use xlinkHref="#icon-rating" />
          </svg>
          <svg className="icon icon-rating">
            <use xlinkHref="#icon-rating" />
          </svg>
          <svg className="icon icon-rating">
            <use xlinkHref="#icon-rating" />
          </svg>
        </label>
      </div>
      <div className="filter-item">
        <label className="label">
          <div className="checkbox">
            <input type="checkbox" name="" />
            <span className="checkmark" />
          </div>
          <svg className="icon icon-rating icon--active">
            <use xlinkHref="#icon-rating" />
          </svg>
          <svg className="icon icon-rating icon--active">
            <use xlinkHref="#icon-rating" />
          </svg>
          <svg className="icon icon-rating">
            <use xlinkHref="#icon-rating" />
          </svg>
          <svg className="icon icon-rating">
            <use xlinkHref="#icon-rating" />
          </svg>
          <svg className="icon icon-rating">
            <use xlinkHref="#icon-rating" />
          </svg>
        </label>
      </div>
      <div className="filter-item">
        <label className="label">
          <div className="checkbox">
            <input type="checkbox" name="" />
            <span className="checkmark" />
          </div>
          <svg className="icon icon-rating icon--active">
            <use xlinkHref="#icon-rating" />
          </svg>
          <svg className="icon icon-rating">
            <use xlinkHref="#icon-rating" />
          </svg>
          <svg className="icon icon-rating">
            <use xlinkHref="#icon-rating" />
          </svg>
          <svg className="icon icon-rating">
            <use xlinkHref="#icon-rating" />
          </svg>
          <svg className="icon icon-rating">
            <use xlinkHref="#icon-rating" />
          </svg>
        </label>
      </div>
    </div>
  );

  updateSearch = (params) => {
    this.closeFilter();
    this.props.updateSearch(params);
  };

  render() {
    const {
      filters,
      search,
      categories,
      updateSearch,
      userIsAuthenticated,
      contractSelected,
      spotPermission,
      user,
      mainCategory,
      greenCategories,
      setBreadcrumbItens,
    } = this.props;
    const {
      productTypeItems,
      brandsItems,
      sortByClickP,
      sortByClickB,
      categoryGreen,
    } = this.state;

    const subCategory = mainCategory
      && mainCategory.categories.find(category => search.categories.find(c => c === category.id));

    const pdmsModifiers = (filters.pdms && filters.pdms.modifiers) || [];
    const pdmsParticulars = (filters.pdms && filters.pdms.particulars) || [];
    const selectedPdmModifier = search.pdmsModifiers && search.pdmsModifiers[0];

    let level = 0;

    if (mainCategory && mainCategory.name) {
      setBreadcrumbItens(++level, mainCategory.name, () => this.props.updateSearch({
        categories: [mainCategory.id],
        pdmsModifiers: [],
        pdmsParticulars: [],
        brands: [],
      }));
    }
    if (subCategory && subCategory.name) {
      setBreadcrumbItens(++level, subCategory.name, () => this.props.updateSearch({
        pdmsModifiers: [],
        pdmsParticulars: [],
        brands: [],
      }));
    }
    if (selectedPdmModifier) {
      const pdmBCValue = pdmsModifiers.find(
        it => `${it.id}` === `${selectedPdmModifier}`,
      );
      if (pdmBCValue) setBreadcrumbItens(++level, pdmBCValue.value, undefined, 'pdmmodifier');
    }

    for (var index in search.pdmsParticulars) {
      const particularBCValue = pdmsParticulars.find(
        it => `${it.items[0].id}`
          === `${search.pdmsParticulars[index].split(': ')[1]}`,
      );
      if (particularBCValue) {
        setBreadcrumbItens(
          ++level + index,
          `${particularBCValue.value}: ${particularBCValue.items[0].value}`,
          undefined,
          `pdmparticular${index}`,
        );
        console.log(particularBCValue);
      }
    }

    if (filters && filters.brands) {
      for (var index in search.brands) {
        const brand = filters.brands.find(b => b.id == search.brands[index]);
        if (brand) setBreadcrumbItens(++level + index, brand.value);
      }
    }

    return (
      <div className="search-filters contentBoxFixed">
        {isMobile && (
          <div>
            <FontAwesomeIcon
              icon={faTimes}
              color="#27348b"
              className="fa-2x overflow closeBoxFixed"
              style={{
                top: '10px',
                right: '30px',
                position: 'absolute',
              }}
            />
            <p style={{ marginBottom: '12px' }} />
          </div>
        )}
        {this.renderProductsSection({
          type: search.type,
          onClick: updateSearch,
          contractSelected,
          spotPermission,
          user,
          userIsAuthenticated,
          categorySelected: search.categories,
          categoryGreen,
        })}

        {this.renderSection({
          title: I18n.t('categories').toUpperCase(),
          items: categories.map(category => ({
            id: category.id,
            value: category.name,
          })),
          selected: mainCategory && mainCategory.id,
          onClick: updateSearch,
          clickAttr: 'categories',
          basicAttrs: {
            greenIndicators: [],
            brands: [],
            pdmsModifiers: [],
            pdmsParticulars: [],
          },
        })}

        {greenCategories
          && this.renderSection({
            title: I18n.t('greenIndicators').toUpperCase(),
            items: greenCategories.map(greenCategory => ({
              id: greenCategory.greenIndicatorId,
              value: greenCategory.descriptionGreen,
            })),
            selected: Number(search.greenIndicators),
            onClick: updateSearch,
            clickAttr: 'greenIndicators',
            basicAttrs: {
              type: 'green_offer',
              brands: [],
              pdmsModifiers: [],
              pdmsParticulars: [],
            },
          })}

        {this.renderSection({
          title: I18n.t('productType').toUpperCase(),
          items: productTypeItems(selectedPdmModifier, pdmsModifiers),
          selected: selectedPdmModifier,
          onClick: updateSearch,
          clickAttr: 'pdmsModifiers',
          basicAttrs: { pdmsParticulars: [] },
          reset: () => updateSearch({ pdmsModifiers: [], pdmsParticulars: [] }),
          sortOnClick: this.productTypeClick,
          sortByClickIcon: sortByClickP,
          typeClassElement: 'checkbox',
        })}

        {selectedPdmModifier
          && pdmsParticulars.map(pdmsParticular => this.renderSection({
            key: pdmsParticular.id,
            title: pdmsParticular.value,
            items: pdmsParticular.items,
            selected:
                search.pdmsParticulars
                && (
                  search.pdmsParticulars.find(
                    p => p.split(': ')[1] === pdmsParticular.items[0].id,
                  ) || ''
                ).split(': ')[1],
            onClick: searchValues => this.updatePdmParticulars(
              pdmsParticular.id,
              searchValues.pdmsParticulars,
            ),
            clickAttr: 'pdmsParticulars',
            reset: () => this.updatePdmParticulars(pdmsParticular.id),
            typeClassElement: 'checkbox',
          }))}

        {filters
          && filters.brands
          && this.renderSection({
            title: I18n.t('brands').toUpperCase(),
            items: brandsItems(filters.brands),
            onClick: updateSearch,
            selected: search.brands && Number(search.brands[0]),
            clickAttr: 'brands',
            reset: () => updateSearch({ brands: [] }),
            sortOnClick: this.brandsClick,
            sortByClickIcon: sortByClickB,
            typeClassElement: 'checkbox',
          })}

        <span className="overflow closeBoxFixed" />
      </div>
    );
  }
}
class ProductsPage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      maxSearchedCarousel: ProductsData.maxSearchedCarouselTabs,
      displayByPages: ProductsData.displayByPages,
      updatedBreadcrumb: 'all',
    };

    this.breadcrumbItens = [
      {
        value: I18n.t('products'),
        link: ROUTES.PRODUCTS,
      },
    ];
  }

  componentDidMount = () => {
    setTimeout(() => {
      refreshPage(this.updateItems, this.props.getProductsRecommended);
    }, 0);
  };

  componentWillUnmount = () => {
    removeScript('/scripts/search.min.js');
  };

  setBreadcrumbItens = (index, value, click, changed = '') => {
    this.breadcrumbItens.splice(index);
    if (
      !this.breadcrumbItens[index]
      || (this.breadcrumbItens[index]
        && this.breadcrumbItens[index].value != value)
    ) {
      this.breadcrumbItens[index] = { value, click };
    }
    if (changed) this.setState({ updatedBreadcrumb: changed });
  };

  componentWillReceiveProps = async (nextProps) => {
    if (nextProps.contractId !== this.props.contractId) {
      refreshPage(this.updateItems, this.props.getProductsRecommended);
    }
  };

  getSearch = () => {
    const params = queryString.parse(
      (this.props.location.search || '').replace(/[+]/g, '%2B'),
    );

    return {
      text: params.text,
      categories:
        params.categories && params.categories.split(';').map(c => Number(c)),
      brands: params.brands && params.brands.split(';'),
      pdmsModifiers: params.pdmsModifiers && params.pdmsModifiers.split(';'),
      pdmsParticulars:
        params.pdmsParticulars && params.pdmsParticulars.split(';'),
      type: params.type,
      page: params.page || 1,
      order: params.order || 'relevance',
      isFilterUpdate: params.isFilterUpdate,
      minPrice: params.minPrice,
      maxPrice: params.maxPrice,
      limit: params.limit || this.state.displayByPages[0].value,
      greenIndicators: params.greenIndicators,
    };
  };

  updateSearch = (newSearch, goToTop = false) => {
    const searchTerms = {
      ...this.getSearch(),
      ...newSearch,
      isFilterUpdate: 1,
    };

    if (!newSearch.page) searchTerms.page = 1;

    const urlParameters = Object.entries(searchTerms)
      .map(e => e.map(a => (Array.isArray(a) ? a.join(';') : a)).join('='))
      .join('&');

    history.push(`${ROUTES.PRODUCTS}?${urlParameters}`);
    if (goToTop) window.scrollTo(0, 0);
  };

  resetSearch = () => {
    const { headerRef } = this.props;
    if (headerRef && headerRef.current) headerRef.current.clearSearch();
    history.push(ROUTES.PRODUCTS);
  };

  updateItems = async () => {
    const searchTerms = this.getSearch();
    if (!searchTerms.isFilterUpdate) window.scrollTo(0, 0);
    const needResetFilters = Number(searchTerms.page) === 1 || !this.props.filters;
    await this.props.getProducts(searchTerms, needResetFilters);
    window.scrollTo(0, 0);
  };

  handlePageClick = (data) => {
    const { selected: pageIndex } = data;
    this.updateSearch({ page: pageIndex + 1 });
  };

  onChangeTopFilterPrice = e => this.updateSearch({ order: e.target.value });

  onChangeDisplayProductQuantityByPage = quantityByPage => this.updateSearch({ limit: quantityByPage });

  renderFilters = () => null;

  renderProducts = products => products.map((product, index) => (
    <ProductItem
      key={`${product.id}${index}`}
      product={product}
      headerRef={this.props.headerRef}
      clickLocation="search"
      clickPosition={index}
      location={this.props.location}
      isSearchPage
    />
  ));

  renderPagination = ({
    page = 0,
    pages = 0,
    handlePageClick,
    marginPagesDisplayed = 1,
    pageRangeDisplayed = 5,
  }) => (
    <div className="search-products__pagination">
      <React.Fragment>
        {(pages || 0) > 0 && (
          <ReactPaginate
            previousLabel={I18n.t('before')}
            nextLabel={I18n.t('next')}
            pageCount={pages}
            marginPagesDisplayed={marginPagesDisplayed}
            pageRangeDisplayed={pageRangeDisplayed}
            forcePage={page - 1}
            onPageChange={handlePageClick}
            containerClassName=""
            pageClassName="cursorPointer"
            pageLinkClassName="cursorPointer"
            activeClassName="active"
            activeLinkClassName="active"
            breakClassName=""
            breakLinkClassName="cursorPointer"
            previousClassName="cursorPointer"
            nextClassName="cursorPointer"
          />
        )}
      </React.Fragment>
    </div>
  );

  renderSearched = (products = []) => (
    <div className="section">
      <div className="container">
        <span className="section__title">{I18n.t('productSearched')}</span>

        <div className="product-recommended">
          <div className="product-recommended__filter">
            <a className="filter active" data-filter="todos" href="javscript:;">
              {I18n.t('all').toUpperCase()}
            </a>
            {products
              .reduce((ctg, value) => {
                if (
                  ctg.length <= this.state.maxSearchedCarousel
                  && ctg.findIndex(el => el.id === value.category.id) === -1
                ) ctg.push(value.category);
                return ctg;
              }, [])
              .map(categ => (
                <a
                  key={categ.name}
                  className="filter"
                  data-filter={categ.id}
                  href="javscript:;"
                >
                  {categ.name.toUpperCase()}
                </a>
              ))}
          </div>

          <div className="swiper-product-recommended swiper-container">
            <div className="swiper-wrapper">
              {products.map(product => (
                <div
                  key={`${product.id}${product.category.id}`}
                  className="swiper-slide"
                  data-category={product.category.id}
                >
                  <ProductItem
                    product={product}
                    headerRef={this.props.headerRef}
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="swiper-product-recommended-prev">
            <svg className="icon icon-arrow-left">
              <use xlinkHref="#icon-arrow-left" />
            </svg>
          </div>
          <div className="swiper-product-recommended-next">
            <svg className="icon icon-arrow-right">
              <use xlinkHref="#icon-arrow-right" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );

  render() {
    const {
      products = [],
      filters = {},
      productsRecommended = [],
      categories = [],
      isAuthenticated,
      contractSelected,
      spotPermission,
      user,
      greenCategories,
      banners,
    } = this.props;

    const search = this.getSearch();
    const mainCategory = search.categories
      && categories.find(
        category => search.categories.find(c => c === category.id)
          || search.categories.find(c => category.categories.find(s => s.id === c)),
      );

    const isGreenCategory = (mainCategory && mainCategory.name === 'PORTFÓLIO VERDE')
      || mainCategory && mainCategory.categories.find(
        category => category.id === search.categories[0],
      );

    return (
      <main>
        <div className="breadcrumb-container">
          <Breadcrumb
            items={this.breadcrumbItens}
            updatedBreadcrumb={this.state.updatedBreadcrumb}
          />
        </div>

        <div className="container search-container">
          <ProductsFilters
            filters={filters}
            search={search}
            sidebarFilters={this.props.setFiltersSidebar}
            updateSearch={this.updateSearch}
            resetSearch={this.resetSearch}
            categories={categories}
            mainCategory={mainCategory}
            productsRecommended={productsRecommended}
            setBreadcrumbItens={this.setBreadcrumbItens}
            contractSelected={contractSelected}
            spotPermission={spotPermission}
            user={user}
            greenCategories={greenCategories}
            userIsAuthenticated={isAuthenticated}
          />

          <div style={{ width: '100%' }}>
            {(search && search.type === 'greenOffer') || isGreenCategory ? (
              <div className="swiper-home-banner swiper-container">
                <div className="swiper-wrapper" style={{ maxHeight: '300px', maxWidth: '900px' }}>
                  <Banner
                    style={{
                      marginBottom: '30px',
                      padding: '0',
                      ...(isMobile ? {} : { paddingLeft: '15px' }),
                      classContainer: 'swiper-slide',
                    }}
                    banners={banners}
                    typeBanner={2}
                  />
                </div>
                <div
                  className="swiper-banner-pagination"
                  style={{
                    display: 'flex',
                    gap: '1rem',
                    position: 'absolute',
                    zIndex: 10,
                    justifyContent: 'center',
                    opacity: '1',
                    cursor: 'pointer',
                    borderRadius: '100%',
                    maxWidth: '900px',
                    maxHeight: '300px',
                  }}
                />
                <div className="swiper-banner-button-prev" />
                <div className="swiper-banner-button-next" />
              </div>
            ) : ''}

            <div className="search-products">
              <span className="search-qnt">
                {`${I18n.t('productsFounded')} ${filters.total}`}
              </span>

              <button type="button" className="search-open openSearchFilter">
                <span />
                {' '}
                Filtros
              </button>

              <div className="search-list">{this.renderProducts(products)}</div>

              {this.renderPagination({
                page: this.getSearch().page,
                pages: filters.pages,
                total: filters.total,
                handlePageClick: this.handlePageClick,
                marginPagesDisplayed: undefined,
                pageRangeDisplayed: isMobile ? 1 : undefined,
              })}
            </div>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => ({
  contractId: state.contracts.selected && state.contracts.selected.client.id,
  products: state.products.list,
  filters: state.products.filters,
  productsRecommended: state.products.recommended,
  categories: state.settings.categories,
  isAuthenticated: state.auth.authenticated,
  spotPermission:
    state.contracts.selected && state.contracts.selected.spotPermission,
  contractSelected: state.contracts && state.contracts.selected,
  user: state.auth.user,
  orderType: state.products.orderType,
  filtersSubCategories: state.products.sortByClickS,
  filtersPdms: state.products.sortByClickP,
  filtersBrands: state.products.sortByClickB,
  banners: state.settings.home && state.settings.home.banners,
});

const mapDispatchToProps = dispatch => ({
  getProducts: (search, resetFilter) => dispatch(getProductsSearch(search, resetFilter)),
  getProductsRecommended: force => dispatch(getProductsRecommended(force)),
  getProductsSearched: force => dispatch(getProductsRecommended(force)),
  setOrderType: orderType => dispatch(setOrderType(orderType)),
  setFiltersSidebar: (sortByClickS, sortByClickP, sortByClickB) => dispatch(setFiltersSidebar(sortByClickS, sortByClickP, sortByClickB)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductsPage);
